import React from 'react'
import { Link } from "react-router-dom"
import path from '../../Assets/path-image.svg'
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';
	
const Path = () => {


	useEffect(() => {
		AOS.init({
		  disable: "phone",
		  duration: 700,
		//   easing: "ease-out-cubic",
		});
	  }, []);

	  
	return (
		<div className='path-section'>
			<div className="container-main">
				<div className="row">
					<div className="col-lg-12">
						<h5 className='path-samll-text montserrat'>Start Your Path</h5>
						<h1 className='path-main-heading montserrat'>Various Learning Paths To <span className='montserrat path-main-block-text'> Achieve Success</span></h1>
					</div>
					<div className="col-lg-6">
						<div className="path-image" data-aos="fade-right">
								<img src={path} className='path-image-main' alt="" />
						</div>
					</div>
					<div className="col-lg-6">
						<div className="path-content" data-aos="fade-left">
							<h2 className='montserrat path-sub-main-heading'>Limitless Learning, <span className='path-block-text montserrat'>Limitless Possibilities !</span> </h2>
							<p className='path-small'>Q-Garden stands as a beacon of empowerment, nurturing women through education and self-development. Guided by the mission of "women empowerment through education," the institution is dedicated to fostering a generation of compassionate, empowered mothers equipped with the skills to navigate and thrive amidst the challenges of modern society. Q-Garden's holistic approach not only focuses on academic excellence but also on building life skills, moral values, and leadership qualities, preparing women to create a positive impact on their families and communities. With diverse learning paths and limitless possibilities, Q-Garden offers an inspiring environment where dreams are nurtured, potentials are realized, and success becomes achievable.</p>
							<div className="path-items">
							<p className='path-item-text'> <i class="ri-arrow-right-s-fill"></i>Setting up an exclusive and advanced academic atmosphere of learning for girls.							</p>
								<p className='path-item-text'> <i class="ri-arrow-right-s-fill"></i>Framing the motherly locus to foster the generations</p>
								<p className='path-item-text'> <i class="ri-arrow-right-s-fill"></i> Inculcating moral values by raising spiritual levels of the students.</p>
								<p className='path-item-text'> <i class="ri-arrow-right-s-fill"></i> Enhancing the memorization skills using traditional and psychological methods</p>
							</div>
							<Link  className="btn explore-btn-about" to='/'>Explore Now</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Path